import React, { useEffect, useRef, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import CenterWiseIncidentModal from './CenterWiseIncidentsModal';
import moment from 'moment';
const TopCentersIncidents = ({ data, incident_details }) => {
  const DEFAULT_INCIDENT_DETAILS_MODAL = {
    center_id: null,
    show: false,
    title: 'Incident Details',
  };
  const [showIncidentDetailsModal, setShowIncidentDetailsModal] = useState(
    DEFAULT_INCIDENT_DETAILS_MODAL
  );
  const [modalData, setModalData] = useState([]);
  const targetRef = useRef(null);
  const [state, setState] = React.useState(null);
  useEffect(() => {
    setState({
      series: [
        {
          name: 'Incidents',
          data: data?.data,
        },
      ],
      options: {
        chart: {
          // height:150,
          type: 'bar',
          background: 'transparent', // Remove the background
          toolbar: {
            show: true, // Enable or disable the toolbar
            tools: {
              download: false, // Disable the download option
            },
          },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const clickedCategory = data?.categories[config.dataPointIndex];
              const incidents = incident_details
                .flat()
                .filter((incident) => incident.center_name === clickedCategory)
                .sort(
                  (a, b) =>
                    moment(b.incident_timestamp).valueOf() -
                    moment(a.incident_timestamp).valueOf()
                );

              if (incidents) {
                setModalData(incidents);

                setShowIncidentDetailsModal((prev) => ({
                  ...prev,
                  show: true,
                }));
              }
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758'],
          },
        },
        plotOptions: {
          bar: {
            columnWidth: '30%', // Set bar width as a percentage of the available space (adjust this value)
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          },
        },

        xaxis: {
          categories: data?.categories,
          // position: 'top',
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
          },
        },
        //   grid: {
        //     show: false, // Disable the grid lines
        //   },
        fill: {
          opacity: 1, // Ensure bars are filled with color without any transparency
        },
        colors: ['#ED1D24'],
      },
    });
  }, [data]);
  return (
    <>
      {state && (
        <ReactApexChart
          options={state.options}
          series={state.series}
          type='bar'
          height={200}
        />
      )}
      {showIncidentDetailsModal.show && (
        <CenterWiseIncidentModal
          showIncidentDetailsModal={showIncidentDetailsModal}
          setShowIncidentDetailsModal={setShowIncidentDetailsModal}
          incidents={modalData}
        />
      )}
    </>
  );
};
export default TopCentersIncidents;
